import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=97d795f6&"
import script from "./copy.vue?vue&type=script&lang=js&"
export * from "./copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97d795f6')) {
      api.createRecord('97d795f6', component.options)
    } else {
      api.reload('97d795f6', component.options)
    }
    module.hot.accept("./copy.vue?vue&type=template&id=97d795f6&", function () {
      api.rerender('97d795f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/copy.vue"
export default component.exports